import { FC, SVGProps } from 'react';

const CloseIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#2d2d2d', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path d="M5 5L15 15" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15 5L5 15" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default CloseIcon;
